import { ElementEventIds } from '@agoda/analytics-messages-definition-activities';
import {
    ActivitiesAdultCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesAdultCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesBookCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesBookCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesChildCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesChildCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesInfantCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesInfantCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesPersonCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesPersonCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesSeniorCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesSeniorCounterPlusClickEventActivitiesFieldsV3,
    ActivitiesYouthCounterMinusClickEventActivitiesFieldsV3,
    ActivitiesYouthCounterPlusClickEventActivitiesFieldsV3,
} from '@agoda/analytics-messages-definition-activities/events.split';
import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import {
    ActivitiesAdultCounterMinusClickEventActivitiesManifestV3,
    ActivitiesAdultCounterPlusClickEventActivitiesManifestV3,
    ActivitiesBookCounterMinusClickEventActivitiesManifestV3,
    ActivitiesBookCounterPlusClickEventActivitiesManifestV3,
    ActivitiesChildCounterMinusClickEventActivitiesManifestV3,
    ActivitiesChildCounterPlusClickEventActivitiesManifestV3,
    ActivitiesInfantCounterMinusClickEventActivitiesManifestV3,
    ActivitiesInfantCounterPlusClickEventActivitiesManifestV3,
    ActivitiesPersonCounterMinusClickEventActivitiesManifestV3,
    ActivitiesPersonCounterPlusClickEventActivitiesManifestV3,
    ActivitiesSeniorCounterMinusClickEventActivitiesManifestV3,
    ActivitiesSeniorCounterPlusClickEventActivitiesManifestV3,
    ActivitiesYouthCounterMinusClickEventActivitiesManifestV3,
    ActivitiesYouthCounterPlusClickEventActivitiesManifestV3,
} from '@agoda/analytics-messages-definition-activities/manifest/events';

interface PaxEventIds {
    plusEventIds: ElementEventIds;
    minusEventIds: ElementEventIds;
}

export type PaxEventFields =
    | ActivitiesInfantCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesInfantCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesSeniorCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesSeniorCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesYouthCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesYouthCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesChildCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesChildCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesAdultCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesAdultCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesPersonCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesPersonCounterMinusClickEventActivitiesFieldsV3
    | ActivitiesBookCounterPlusClickEventActivitiesFieldsV3
    | ActivitiesBookCounterMinusClickEventActivitiesFieldsV3;

export const getPaxEventIds = (paxType: PaxTypeCode): PaxEventIds => {
    switch (paxType) {
        case PaxTypeCode.INFANT:
            return { plusEventIds: ActivitiesInfantCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesInfantCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.SENIOR:
            return { plusEventIds: ActivitiesSeniorCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesSeniorCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.YOUTH:
            return { plusEventIds: ActivitiesYouthCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesYouthCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.CHILD:
            return { plusEventIds: ActivitiesChildCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesChildCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.ADULT:
            return { plusEventIds: ActivitiesAdultCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesAdultCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.PERSON:
            return { plusEventIds: ActivitiesPersonCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesPersonCounterMinusClickEventActivitiesManifestV3.ids };
        case PaxTypeCode.BOOK:
            return { plusEventIds: ActivitiesBookCounterPlusClickEventActivitiesManifestV3.ids, minusEventIds: ActivitiesBookCounterMinusClickEventActivitiesManifestV3.ids };
        default:
            return { plusEventIds: {} as ElementEventIds, minusEventIds: {} as ElementEventIds };
    }
};
